import { OrganisationFeatureFlags } from 'shared';
import { Navigate, Outlet } from 'react-router';

import { Card } from '../../../common/Atoms/Card';
import { Notification } from '../../../common/Atoms/Notification';
import { ITab, Tabs } from '../../../common/Atoms/Tabs';
import { useGetSelectedOrganisation } from '../../hooks/useGetSelectedOrganisation';

export function AgentsRoot() {
  const currentOrg = useGetSelectedOrganisation();
  const aiAgentEnabled = !!currentOrg?.featureFlags?.includes(OrganisationFeatureFlags.AI_AGENT);

  if (!aiAgentEnabled) {
    return <Navigate
      to={ `..` }
      replace />;
  }

  const tabs: ITab[] = [
    {
      name: `Conversations`,
      href: `conversations`,
    },
    // {
    //   name: `Rules`,
    //   href: `rules`,
    // },
    {
      name: `Agent Settings`,
      href: `agent-settings`,
    },
  ];

  return (
    <Card>
      <Notification
        type={ `info` }
        title={ `Early access` }
        className={ `mb-4` }
      >
        { `The AI agent is in early access and can make mistakes. Check what it does and contact support with any ideas, questions or concerns.` }
      </Notification>

      <Tabs
        tabs={ tabs }
      />

      <Outlet />
    </Card>
  );
}
